var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 13,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_28",
    "data-name": "Repeat Grid 28",
    opacity: 0.6,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1309 -222)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 222)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1304 -222)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309-2",
    "data-name": "Ellipse 309",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 222)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1309 -217)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309-3",
    "data-name": "Ellipse 309",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 222)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1304 -217)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309-4",
    "data-name": "Ellipse 309",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 222)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1309 -212)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309-5",
    "data-name": "Ellipse 309",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 222)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1304 -212)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309-6",
    "data-name": "Ellipse 309",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 222)",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag_icon.fabd7b8a2327fbe4921f9d7d04f0d06a.svg";
export { ForwardRef as ReactComponent };